import { Modal, ModalBody, ModalFooter, ModalHeader, ModalProps } from "@/components/Modal/Modal";
import styles from './InventoryExportModal.module.css';
import Button from "@/components/forms/Button/Button";
import { useState } from "react";
import { exportBuyCosts } from "@/api/buy-cost";

export interface InventoryExportModalProps extends Omit<ModalProps, 'onOpenChange'> {
  onModalOpenChange: (open: boolean) => void;
}

export default function InventoryExportModal({ onModalOpenChange, ...restModalProps }: InventoryExportModalProps) {
  const [isLoadingExport, setIsLoadingExport] = useState<boolean>(false);

  const handleExport = async () => {
    setIsLoadingExport(true);
    try {
      const response = await exportBuyCosts() as Blob;
      // download response
      const fileURL =
        window.URL.createObjectURL(response);

      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = `buy-cost-export-${Date.now()}.csv`;
      alink.click();
    } catch (error) {
      console.log("Export error", error);

    } finally {
      setIsLoadingExport(false);
      onModalOpenChange(false);
    }
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      if (isLoadingExport) {
        return;
      } else {
        onModalOpenChange(open);
      }
    } else {
      onModalOpenChange(open);
    }
  }

  return (
    <Modal
      {...restModalProps}
      closeIcon={!isLoadingExport}
      onOpenChange={handleOpenChange}
      className={styles.modal}
    >
      <ModalHeader>
        <div className={styles.title}>
          Export Inventory
        </div>
      </ModalHeader>

      <ModalBody divider>
        <div className={styles.exportContent}>
          <p className={styles.exportTitle}>Download a CSV file with your listings. </p>
          <p className={styles.exportSubheading}>Use the file for editing and managing your inventory.</p>
        </div>
      </ModalBody>

      <ModalFooter>
        <div className={styles.buttons}>
          <Button type={"secondary"} onClick={() => onModalOpenChange(false)}>
            Cancel
          </Button>
          <Button type="primary"
            disabled={isLoadingExport}
            onClick={handleExport}>
            <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><g fill="currentColor"><path d="M8.997 3v5.433L10.731 6.7l.933.967L8.331 11 4.997 7.667l.934-.967 1.733 1.733V3h1.333Z" /><path d="M4.333 13.634c-.366 0-.68-.13-.941-.392A1.284 1.284 0 0 1 3 12.301v-2h1.333v2h8v-2h1.334v2c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.942.392h-8Z" /></g></svg>
            {isLoadingExport ? 'Downloading...' : 'Export'}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  )
}